import {
  getWaypointCategoryVisual,
  IAreaWaypoint,
  IGeoJSON,
  ILocationInfo,
  WaypointCategoryEnum,
} from "@ryde/shared";

import { collectPolygonLocations } from "../../../common/map/maplibre";

export const areaWaypointVisual = getWaypointCategoryVisual(
  WaypointCategoryEnum.AreaWaypoint,
);

/** Frame the area polygon when it has vertices; otherwise keep the waypoints-only fit. */
export const getAreaWaypointsMapFitLocations = ({
  waypoints,
  polygon,
}: {
  waypoints: IAreaWaypoint[];
  polygon?: IGeoJSON | null;
}): ILocationInfo[] => {
  const polygonLocations = collectPolygonLocations([
    { id: 0, color: "", polygon: polygon ?? undefined },
  ]);
  return polygonLocations.length ? polygonLocations : waypoints;
};
